function openImageModal(url: string, alt: string): void {
    const backdrop = document.createElement("div");
    backdrop.className = "admin-modal__backdrop";

    const box = document.createElement("div");
    box.className = "admin-modal__box admin-modal__box--image";
    box.innerHTML = `
        <div class="admin-modal__head">
            <h2 class="admin-modal__title">${alt}</h2>
            <button type="button" class="admin-modal__close" aria-label="닫기">&times;</button>
        </div>
        <div class="admin-modal__body">
            <img src="${url}" alt="${alt}" class="admin-modal__preview-img">
        </div>
    `;

    const modal = document.createElement("div");
    modal.className = "admin-modal";
    modal.appendChild(backdrop);
    modal.appendChild(box);
    document.body.appendChild(modal);

    const close = (): void => modal.remove();

    box.querySelector(".admin-modal__close")?.addEventListener("click", close);
    backdrop.addEventListener("click", close);
    document.addEventListener(
        "keydown",
        (e: KeyboardEvent) => {
            if (e.key === "Escape") close();
        },
        { once: true },
    );
}

export function initThumbPreview(): void {
    document.addEventListener("click", (e) => {
        const img = (e.target as Element).closest<HTMLImageElement>(
            ".admin-table__thumb[data-preview-url]",
        );
        if (!img) return;
        const url = img.dataset.previewUrl ?? img.src;
        const alt = img.alt || "이미지 미리보기";
        openImageModal(url, alt);
    });
}
